/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request model for updating student enrollment state
 */
export interface StudentStateUpdateRequest {
  state: string;
}
